import React, { useRef } from 'react'
import useResizeObserver from 'use-resize-observer'
import { relativeRect } from '@app/components/useClientRect'
import { TrackSelect } from '@app/components/TrackSelect'
import { RaceResults } from '@app/components/RaceResults'
import { Canvas } from '@app/components/Canvas'
import { observer } from 'mobx-react-lite'

export const NewView = observer(() => {
  let qualifyingRect: ClientRect
  let lapTimesRect: ClientRect
  let pitStopRect: ClientRect
  const [resizeRef, width, height] = useResizeObserver()
  const qualifyingRef = useRef(null)
  const lapTimesRef = useRef(null)
  const pitStopRef = useRef(null)

  if (
    resizeRef.current !== null &&
    qualifyingRef.current !== null &&
    lapTimesRef.current !== null &&
    pitStopRef.current !== null
  ) {
    qualifyingRect = relativeRect(qualifyingRef.current, resizeRef.current)
    lapTimesRect = relativeRect(lapTimesRef.current, resizeRef.current)
    pitStopRect = relativeRect(pitStopRef.current, resizeRef.current)
  }

  return (
    <div className="max-w-6xl mx-auto pl-4">
      <TrackSelect />
      <div className="lg:flex -ml-4 lg:ml-4 relative items-start">
        <div className="overflow-x-auto w-full">
          <div
            className="lg:flex flex-grow relative w-192 lg:w-auto"
            ref={resizeRef as React.RefObject<HTMLDivElement>}
          >
            {resizeRef && qualifyingRect && lapTimesRect && pitStopRect && (
              <Canvas
                width={width}
                height={height}
                qualifyingRect={qualifyingRect}
                lapTimesRect={lapTimesRect}
                pitStopRect={pitStopRect}
              />
            )}
            <div className="lg:w-48 mt-8 lg:mt-0 relative z-10">
              <div
                className="lg:h-112 h-48 w-64 lg:w-auto"
                ref={qualifyingRef}
              />
            </div>
            <div className="flex-grow mt-8 lg:mt-0 relative z-10">
              <div className="h-112" ref={lapTimesRef} />
              <div
                className="flex-grow h-36 flex items-center justify-center"
                ref={pitStopRef}
              ></div>
            </div>
          </div>
        </div>
        <div className="lg:w-96 relative z-10 pr-4 mt-8 lg:mt-0">
          <RaceResults />
        </div>
      </div>
    </div>
  )
})
